var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSubscriberPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6645 11.666C14.2418 11.666 16.331 9.57675 16.331 6.99951C16.331 4.42227 14.2418 2.33301 11.6645 2.33301C9.08731 2.33301 6.99805 4.42227 6.99805 6.99951C6.99805 9.57675 9.08731 11.666 11.6645 11.666Z",
    stroke: "#7663EB",
    strokeWidth: 1.74994
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4979 11.6663H22.1647M22.1647 11.6663H19.8314M22.1647 11.6663V9.33301M22.1647 11.6663V13.9995M20.9957 20.9993C20.9973 20.8079 20.998 20.6135 20.998 20.4159C20.998 17.5169 16.8192 15.1661 11.665 15.1661C6.51088 15.1661 2.33203 17.5169 2.33203 20.4159C2.33203 23.315 2.33203 25.6658 11.665 25.6658C14.2678 25.6658 16.1449 25.4826 17.4982 25.1559",
    stroke: "#7663EB",
    strokeWidth: 1.74994,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSubscriberPrimary);
export default __webpack_public_path__ + "static/media/newSubscriber-primary.2c57b5a78a8ce684e4001516c37e8b60.svg";
export { ForwardRef as ReactComponent };